import type { AccentColorName } from '../../constants/colors'

import type {
  ProgressBarSize,
  ProgressCircleSize,
  ProgressState
} from './types'

/** Maps each semantic state to the shared accent color it renders with. */
export const PROGRESS_STATE_ACCENT: Record<ProgressState, AccentColorName> = {
  default: 'primary',
  success: 'success',
  error: 'error'
}

/** Maps each semantic state to antd's own `Progress` `status` prop. */
export const PROGRESS_STATUS_MAP: Record<
  ProgressState,
  'normal' | 'success' | 'exception'
> = {
  default: 'normal',
  success: 'success',
  error: 'exception'
}

/** Bar thickness (px) per size — the only thing `size` changes on the bar. */
export const PROGRESS_BAR_HEIGHT: Record<ProgressBarSize, number> = {
  small: 4,
  default: 6,
  large: 8
}

/** Ring diameter (px) per size. */
export const PROGRESS_CIRCLE_DIAMETER: Record<ProgressCircleSize, number> = {
  small: 50,
  large: 80
}
